import translationAr from '@/translations/translationAr'
import translationEn from '@/translations/translationAr'
import issueUtils from '@/utils/issue'

export default {
  isValidString: (value: unknown) => {
    return typeof value === 'string' && value === value.trim()
  },
  isStringNumber: (value: unknown) => {
    return typeof value === 'string' && value === value.trim() && !isNaN(parseFloat(value))
  },
  isTypeString: (value: unknown) => {
    return typeof value === 'string'
  },
  isTypeBoolean: (value: unknown) => {
    return typeof value === 'boolean'
  },
  isNotEmptyString: (value: unknown) => {
    return typeof value === 'string' && value === value.trim() && value.length > 0
  },
  isTypeUndefined: (value: unknown) => {
    return typeof value === 'undefined'
  },
  isArray: (value: unknown) => {
    return Array.isArray(value)
  },
  isTypeNumber: (value: unknown) => {
    return typeof value === 'number'
  },
  isPositiveNumber: (value: unknown) => {
    return typeof value === 'number' && value > 0
  },
  isValidStringLocalization: (value: unknown) => {
    return (
      typeof value === 'string' &&
      value === value.trim() &&
      value in translationAr.issue &&
      value in translationEn.issue
    )
  },
  isValidRole: (value: unknown) => {
    return typeof value === 'string' && ['client', 'driver'].includes(value)
  },
  isValidOtpOperation: (value: unknown) => {
    return (
      typeof value === 'string' &&
      ['change-phone', 'register', 'reset-password', 'login'].includes(value)
    )
  },
  isValidIssueType: (value: unknown) => {
    return typeof value === 'string' && ['general', 'ride'].includes(value)
  },
  isValidLanguage: (value: unknown) => {
    return typeof value === 'string' && ['ar', 'en'].includes(value)
  },
  isValidDevice: (value: unknown) => {
    return typeof value === 'string' && ['android', 'ios'].includes(value)
  },
  isValidInputType: (value: unknown) => {
    return (
      typeof value === 'string' && ['select', 'textarea', 'text', 'date', 'number'].includes(value)
    )
  },
  isValidDriverAttachment: (value: unknown) => {
    return typeof value === 'string' && ['license', 'driver', 'ssn'].includes(value)
  },
  isValidVehicleAttachment: (value: unknown) => {
    return (
      typeof value === 'string' &&
      ['car', 'delegationOrLease', 'insurance', 'registration'].includes(value)
    )
  },
  isValidIssueSubCategory: (value: unknown) => {
    return (
      typeof value === 'string' &&
      value === value.trim() &&
      issueUtils.issues.filter((item) => item.subCategory === value).length > 0
    )
  },
  isValidIssueCode: (value: unknown) => {
    return (
      typeof value === 'string' &&
      value === value.trim() &&
      issueUtils.issues.filter((item) => item.code === value).length > 0
    )
  },
  isValidPaymentOperation: (value: unknown) => {
    return (
      typeof value === 'string' &&
      ['balance-charge', 'add-mada-payment-method', 'add-payment-method', 'apple-pay'].includes(
        value
      )
    )
  },
  isValidPaymentMethod: (value: unknown) => {
    return typeof value === 'string' && ['fawry', 'voucher', 'tamara'].includes(value)
  }
}
